import React from 'react';
import styled from 'styled-components';
import { AppLayout } from '../../components/layout';

const Container = styled.div`
  max-width: 800px;
  margin: 0 auto;
  padding: 40px 20px;
  line-height: 1.6;
`;

const Title = styled.h1`
  font-size: 2.5rem;
  color: #1a365d;
  margin-bottom: 24px;
`;

const Section = styled.section`
  margin-bottom: 40px;
`;

const SubTitle = styled.h2`
  font-size: 1.8rem;
  color: #2c5282;
  margin-bottom: 16px;
`;

const FAQItem = styled.div`
  margin-bottom: 24px;
  padding: 20px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
`;

const Question = styled.h3`
  font-size: 1.2rem;
  color: #2d3748;
  margin-bottom: 10px;
  font-weight: 600;
`;

const Answer = styled.p`
  color: #4a5568;
`;

export const FAQ = () => {
  const faqs = [
    {
      q: "What is ERP Mock?",
      a: "ERP Mock is a specialized enterprise resource planning platform designed for field operations, sales management, and supply chain optimization."
    },
    {
      q: "How do I get access to the demo?",
      a: "You can use the demo credentials provided on the landing page to explore the manager and sales representative experiences."
    },
    {
      q: "Is my data secure?",
      a: "We use industry-standard encryption and security protocols provided by Google Firebase to ensure your data is always protected."
    },
    {
      q: "Can I customize the platform?",
      a: "Yes, ERP Mock is built to be highly customizable. Contact our team at devbob.co@gmail.com for more information on custom implementations."
    }
  ];

  return (
    <AppLayout>
      <Container>
        <Title>Frequently Asked Questions</Title>
        <Section>
          {faqs.map((faq, index) => (
            <FAQItem key={index}>
              <Question>{faq.q}</Question>
              <Answer>{faq.a}</Answer>
            </FAQItem>
          ))}
        </Section>
      </Container>
    </AppLayout>
  );
};
